import {Component, OnInit, Inject, OnDestroy} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import {DialogService} from '@rbaip/ui-component';
import {ItemSummaryAssetControlGroupService} from '../../shared/asset-package/item-summary-asset-control-group.service';
import {AssetPackageDto} from '../../shared/domain/asset-package';
import {getCurrencyCodeAndSymbol} from "../../shared/currencyUtil";

@Component({
  selector: 'lib-item-summary-asset-control-group-budgets',
  templateUrl: './asset-control-group-budgets.component.html',
  styleUrls: ['./asset-control-group-budgets.component.scss']
})
export class AssetControlGroupBudgetsComponent implements OnInit, OnDestroy {

  public assetControlGroupId: number;
  public assetsRnrBudget: number;
  public assetsHaulingBudget: number;
  public rnrBudgetLimit: number;
  public haulingBudgetLimit: number;
  public opportunityCurrency: string;
  public validNumericValue: string;

  private saveBudgetsSubscription: Subscription;

  constructor( @Inject(MAT_DIALOG_DATA) private data: any,
               private dialogRef: MatDialogRef<AssetControlGroupBudgetsComponent>,
               private dialogService: DialogService,
               private assetControlGroupService: ItemSummaryAssetControlGroupService) {
    this.assetControlGroupId = this.data.assetControlGroupId;
    this.assetsRnrBudget = this.data.assetsRnrBudget;
    this.assetsHaulingBudget = this.data.assetsHaulingBudget;
    this.rnrBudgetLimit = this.data.rnrBudgetLimit;
    this.haulingBudgetLimit = this.data.haulingBudgetLimit;
    this.opportunityCurrency = this.data.opportunityCurrency;
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.saveBudgetsSubscription) {
      this.saveBudgetsSubscription.unsubscribe();
    }
  }

  public saveBudgets(): void {
    this.dialogService.showProgress();
    const assetControlGroup = new AssetPackageDto();
    assetControlGroup.acgId = this.assetControlGroupId;
    assetControlGroup.rnrBudgetLimit = this.rnrBudgetLimit;
    assetControlGroup.haulingBudgetLimit = this.haulingBudgetLimit;
    this.saveBudgetsSubscription = this.assetControlGroupService.saveBudgets(assetControlGroup).subscribe(response => {
        if (response.error) {
          this.dialogService.showMessage('Unable to save budgets. Please contact Tech Support.');
          this.dialogService.hideProgress();
          this.dialogRef.close();
        } else {
          this.dialogService.showMessage('Successfully saved budgets !');
          this.dialogService.hideProgress();
          this.dialogRef.close(assetControlGroup);
        }
      });
  }

  public defaultToAssetsRnRBudget(): void {
    this.rnrBudgetLimit = this.assetsRnrBudget;
  }

  public defaultToAssetsHaulingBudget(): void {
    this.haulingBudgetLimit = this.assetsHaulingBudget;
  }

  public isRnRBudgetLimitLessThanAssetBudget(): boolean {
    return this.rnrBudgetLimit < this.assetsRnrBudget;
  }

  public isHaulingBudgetLimitLessThanAssetBudget(): boolean {
    return this.haulingBudgetLimit < this.assetsHaulingBudget;
  }

  /**
   * This method will prevent the decimal numbers
   * @param event
   */
  public preventDecimalValue(event, ngModel) {
    this.validNumericValue = (event.key === '.') ? ngModel : null;
    if (event.key === '.') {
      event.preventDefault();
    }
  }
  public getCurrencyPlaceHolder(): string {
    return getCurrencyCodeAndSymbol(this.opportunityCurrency);
  }

  public isCurrencyPrefixVisible(theValue: any): boolean {
    return theValue != null && theValue !== '';
  }

}
